// The page half of ```iframe embeds (src/services/markdown.ts renderEmbed).
//
// Every embedded frame is a sandboxed srcdoc document with an opaque origin:
// it can't read the page, and the page can't read it — including how tall its
// content is. So the frame measures itself (EMBED_FRAME_SCRIPT, injected into
// the srcdoc) and posts the height here, and this sets the frame's height.
//
// Trust: the message's origin is "null" for every sandboxed frame, so it says
// nothing. What identifies the sender is event.source — it must be the
// contentWindow of one of THIS page's embed frames, or the message is ignored.
// Loaded on every public page and every studio page; with no frames on the
// page it registers one listener and does nothing else.
const MIN = 40;
const MAX = 8000;

window.addEventListener("message", (e: MessageEvent) => {
  const d = e.data as { jbEmbed?: string; height?: unknown } | null;
  if (!d || d.jbEmbed !== "height" || typeof d.height !== "number") return;
  const frames = document.querySelectorAll<HTMLIFrameElement>("iframe.embed-iframe");
  for (const f of frames) {
    if (f.contentWindow === e.source) {
      const h = Math.max(MIN, Math.min(MAX, Math.ceil(d.height)));
      f.style.height = `${h}px`;
      return;
    }
  }
});
